import { NgModule } from '@angular/core';
import { BankCodeTypePipe } from './bank-code-type.pipe';
import { BankCodeTypeService } from './bank-code-type.service';

@NgModule({
  declarations: [BankCodeTypePipe],
  providers: [BankCodeTypeService],
  exports: [BankCodeTypePipe]
})
export class BankCodeTypeModule {}
